module.exports = __webpack_public_path__ + "static/media/angage1.3043650f.webp";